import $ from 'jquery';

export default function init() {
    var $toggle           = $('.js-toggle-language-selector');
    var $languageSelector = $('.js-language-selector__container-mobile');
    var $header = $('.site-header');

    var $toggleSearchBar = $('.js-toggle-search-bar');
    var $searchBar       = $('.js-search-bar-wrapper');

    var $toggleMainNavigation    = $('.js-toggle-main-navigation');
    var $mainNavigation          = $('.js-main-navigation-wrapper');
    var $mainNavigationHideables = $('.js-site-content, .js-main-footer');

    $toggle.click(function (e) {
        e.preventDefault();

        if ($languageSelector.is(":visible")) {
            $toggle.removeClass("active").attr('aria-expanded', false);
            $languageSelector.slideUp(200);
        } else {
            $header.removeClass('navigation-is-open');
            $toggle.addClass("active").attr('aria-expanded', true);
            $languageSelector.slideDown(200);

            $toggleSearchBar.removeClass('active').attr('aria-expanded', false);
            $searchBar.hide();

            $toggleMainNavigation.removeClass('active').attr('aria-expanded', false);
            $mainNavigation.removeClass('active');
            $mainNavigationHideables.show();
        }

    });
}
